import { BaseHook } from './base.hook';

export class FullnameHook extends BaseHook {

  static path = 'YourInformation';

  static execute(path, value, actions) {
    const info = actions.getData('YourInformation');

    if (value) {
      if ((!info || !info.fullName) && value.firstName && value.lastName) {
        const first = value.firstName;
        const middle = value.middleInitial ? `${value.middleInitial}.` : '';
        const last = value.lastName;

        actions.setData('YourInformation.fullName', `${first} ${middle} ${last}`);
      }
    }
  }
}
